import * as yup from 'yup';

export const commonChargeWaiverRegistrationValidation: { [x: string]: any; } = {
    waiverReasonCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createChargeWaiverRegistrationValidation: { [x: string]: any; } = {
    ...commonChargeWaiverRegistrationValidation,
};

export const createChargeWaiverRegistrationValidationSchema = yup.object().shape(createChargeWaiverRegistrationValidation);

